export default __webpack_public_path__ + "static/media/twitter.607128fb.svg";